module.exports = "/images/phone-lg.png?82bb81b2326ed980888550689a8f13b6";